import { Pipe, PipeTransform } from '@angular/core';
import { TranslationService } from '@schoolbelle/common/translation';
import { QuestionTypeTranslationComponent } from './question-type-translation.component';

@Pipe({
  name: 'questionType'
})
export class QuestionTypePipe implements PipeTransform {
  constructor(private translationService: TranslationService) {
    this.translationService.injectComponent(QuestionTypeTranslationComponent);
  }
  transform(value: string): string {
    return this.translationService.get(value) || value;
  }
}
